import { useScrollRestoration } from "@indietabletop/appkit/use-scroll-restoration";
import { ErrorBoundary } from "react-error-boundary";
import { Route, Switch, useLocation } from "wouter";
import { ArmiesListingPage } from "./armies-listing-page";
import { ArmyDetailPage, SharedArmyDetailPage } from "./army-detail-page";
import { DashboardPage } from "./dashboard-page";
import { DatabaseProvider } from "./database-provider";
import { FullscreenDismissBlocker } from "./fullscreen-dismiss-blocker";
import { ChangelogPages, HelpPages, LegalPages } from "./help";
import { MainLayout } from "./main-layout";
import { PrintArmyPage } from "./print-army-page";
import { RulesetProvider } from "./ruleset-provider";
import { ServiceWorkerHandler } from "./service-worker-handler";

import { ErrorView } from "./error-view";
import "./globals.css";

export function App() {
  const [pathname] = useLocation();
  useScrollRestoration(pathname);

  return (
    <ErrorBoundary fallback={<div>We run into an unexpected issue...</div>}>
      <FullscreenDismissBlocker />

      <ServiceWorkerHandler path="/sw.js">
        <DatabaseProvider>
          <RulesetProvider>
            <Switch>
              <Route path="/army/a/:armyId/print" component={PrintArmyPage} />

              <Route>
                <MainLayout>
                  <Switch>
                    <Route path="/" component={DashboardPage} />

                    <Route path="/army" nest>
                      <Switch>
                        <Route path="/" component={ArmiesListingPage} />
                        <Route
                          path="/a/:armyId"
                          component={ArmyDetailPage}
                          nest
                        />
                        <Route
                          path="/s/:shareId"
                          component={SharedArmyDetailPage}
                          nest
                        />
                      </Switch>
                    </Route>

                    <Route path="/changelog" nest>
                      <ChangelogPages />
                    </Route>

                    <Route path="/help" nest>
                      <HelpPages />
                    </Route>

                    <Route path="/legal" nest>
                      <LegalPages />
                    </Route>

                    <Route>
                      <ErrorView
                        heading="Page not found"
                        description="The link you followed might be broken."
                      />
                    </Route>
                  </Switch>
                </MainLayout>
              </Route>
            </Switch>
          </RulesetProvider>
        </DatabaseProvider>
      </ServiceWorkerHandler>
    </ErrorBoundary>
  );
}
